export const featureFlags = {
  NEW_HOME_EQUITY_LEADFORM: 'new-home-equity-lead-form'
};

export const traits = {
  COMPANY_SOURCE: 'company-source'
}
